<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="$t('master.kendaraan')" :subTitle="$t('master.textKendaraan')" />
      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="d-flex float-end">
          <b-dropdown v-if="phaseOneShow" right variant="primary" menu-class="dropdown-menu-end">
            <template #button-content>
              {{ $t('global.action.download') }} <i class="mdi mdi-chevron-down ps-2" />
            </template>
            <b-dropdown-item>
              <i class="bx bx-book-content pe-1" /> {{ $t('master.user.downloadTable') }}
            </b-dropdown-item>
            <b-dropdown-item>
              <i class="bx bx-book-content pe-1" /> {{ $t('master.user.downloadPDF') }}
            </b-dropdown-item>
          </b-dropdown>
          <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
            <div class="float-end d-flex">
              <McButtonBack href="/master/" class="me-2" />
              <McButton
                v-if="!noData"
                variant="primary"
                :text="$t('global.create')"
                icon="icon-fill_plus"
                @click="
                  $router.push({
                    name: 'Master Fleet Create',
                  })
                "
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Table -->
    <FleetTable
      :fields="fields"
      :apiClient="query"
      :customHandlers="customHandlers"
      hasFilter
      :activeFilters="activeFilters"
      :isEmpty="noData"
      :busy="isLoading"
      @refreshData="handleRefreshData"
    >
      <template #button-filter>
        <McInlineFilter
          :filterItems="filteredItems"
          :activeKeys="activeFilters['status']"
          isMultiple
          @update:activeKeys="handleChangeActiveFilters([{ key: 'status', values: $event }])"
        />
      </template>
      <template #viewManager="{ handleSetDataFields, dataFields, initialFields }">
        <McFilterSelect
          :defaultColumnOrder="initialFields"
          :currentColumnOrder="dataFields"
          @setColumn="handleSetDataFields"
          @setField="handleFieldShow"
        />
      </template>
      <template #emptyState>
        <McEmptyState
          :title="$t('maintenance.nolist.noData')"
          :desc="$t('master.service.emptyState.desc')"
          class="pb-4"
          @buttonPrimaryAction="customHandlers.handleAddEmpty"
        />
      </template>
    </FleetTable>
  </Layout>
</template>

<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header-v2'
import Layout from '@/router/layouts/main'
import McButton from '@/components/McButton'
import McInlineFilter from '@/components/McInlineFilter'
import McButtonBack from '@/components/McButtonBack'
import FleetTable from './components/MultiheaderTable'
import McFilterSelect from '@/components/McFilterSelect'
import McEmptyState from '@/components/McEmptyState'
import { mapGetters } from 'vuex'
import { Helper } from '@/mixin/helper'
import { fields } from './lib/fields'

import {
  GET_VEHICLE,
  GET_VEHICLES_PAGINATED,
  VEHICLE_MUTATION_DELETE,
} from '@/services/api/master/fleet'

export default {
  page: {
    title: 'Master',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    McButtonBack,
    FleetTable,
    McInlineFilter,
    McFilterSelect,
    McEmptyState,
  },
  mixins: [Helper],
  apollo: {
    vehicles: {
      query: GET_VEHICLE,
      variables() {
        return {
          filter: {
            status: ['I', 'R', 'A'],
          },
        }
      },
      result({ data }) {
        this.noData = data.vehicles.vehicles.length === 0
        this.isLoading = false
      },
    },
  },
  data() {
    return {
      customHandlers: {
        handleClickRow: (item) => {
          return this.onRowClicked(item)
        },

        handleAddEmpty: () => {
          return this.$router.push({ name: 'Master Fleet Create' })
        },
      },
      phaseOneShow: false,
      activeFilters: {},
      filter: [],
      status: 'I',
      noData: false,
      isLoading: true,
    }
  },
  computed: {
    /**
     * Total no. of records
     */
    title() {
      return this.$t('Kendaraan')
    },

    query() {
      return {
        get: async (filter) => {
          const res = await this.$apollo.query({
            query: GET_VEHICLES_PAGINATED,
            fetchPolicy: 'no-cache',
            variables: {
              filter: {
                parentOnly: true,
                ...filter,
                ...this.activeFilters,
              },
            },
          })

          return res.data.vehiclesPaginated.vehiclesPaginated
        },
        delete: async (id) => {
          const res = await this.$apollo.mutate({
            mutation: VEHICLE_MUTATION_DELETE,
            fetchPolicy: 'no-cache',
            variables: {
              input: {
                id: id,
              },
            },
          })

          return res.data.deleteVehicle.isSuccessful
        },
      }
    },

    fields() {
      const computedFields = []
      fields().forEach((item) => {
        item.label = `${this.$t(item.label)}`
        if (item.fields && Array.isArray(item.fields)) {
          item.fields.forEach((child) => (child.label = `${this.$t(child.label)}`))
        }
        if (item.isShow !== false) {
          computedFields.push(item)
        }
      })

      return computedFields
    },

    filteredItems() {
      return [
        { id: 'all', label: this.$t('global.filter.all') },
        { id: 'I', label: this.$t('global.active') },
        { id: 'R', label: this.$t('global.repair') },
        { id: 'A', label: this.$t('global.archive') },
      ]
    },

    ...mapGetters({
      hasAccess: 'identity/hasAccess',
      hasAccessAll: 'identity/hasAccessAll',
    }),
  },
  methods: {
    onRowClicked(item) {
      if (
        !this.hasAccessAll([
          'vehicles:update',
          'vehicle_audit_logs:read',
          'vehicle_categories:read',
          'devices:read',
          'd1a-default-mdkendaraan:read',
        ])
      ) {
        return
      }
      this.$router.push({
        name: 'Master Fleet Update',
        params: { id: item.id },
      })
    },

    handleChangeActiveFilters(filters) {
      filters.forEach((filter) => {
        this.$delete(this.activeFilters, filter.key)

        // to prevent set the filter in activeFilters if values are null, undefined, or empty string.
        if (
          filter.values === null ||
          filter.values === undefined ||
          filter.values === '' ||
          filter.values === false
        )
          return
        // to prevent set the filter in activeFilters if values are Array with length equal to 0
        if (Array.isArray(filter.values) && filter.values.length === 0) return

        // set the key and values in activeFilters
        this.$set(this.activeFilters, filter.key, filter.values)
      })
    },

    handleRefreshData(value) {
      this.isLoading = value
      setTimeout(() => {
        this.isLoading = !value
      }, 300)
    },

    handleFieldShow(fields) {
      localStorage.setItem('masterFleetFields', JSON.stringify({ column: fields }))
    },
  },
}
</script>
